import { memo, useCallback, useState } from 'react';
import IconButton from '@/components/atoms/Button/IconButton';

function CreateAISearchClipsButton({
  generateClips,
  buttonTextContent
}: {
  generateClips: () => Promise<void>;
  buttonTextContent: string;
}) {
  const [isLoading, setIsLoading] = useState(false);

  const generateMore = useCallback(() => {
    setIsLoading(true);
    generateClips().finally(() => {
      setIsLoading(false);
    });
  }, []);

  return isLoading ? (
    <IconButton
      icon="IconLoader2"
      content=""
      variation="filled"
      size="full"
      disabled={true}
      iconClassName="animate-spin"
      trackingId="loading-more-ai-search-clips-button"
    />
  ) : (
    <IconButton
      icon="IconSparkles"
      content={buttonTextContent}
      variation="filled"
      size="full"
      trackingId="genereate-more-ai-search-clips-button"
      onClick={generateMore}
    />
  );
}

export default memo(CreateAISearchClipsButton);
